export const profiles = [
  {
    api: 'api4getActivitySourceDataProfile',
    filename: 'activitySourceDataProfile'
  },
  { api: 'api4getActivityModeProfileList', filename: 'activityModeProfileList' },
  { api: 'api4getActivityStrengthProfile', filename: 'activityStrengthProfile' },
  { api: 'api4getActivityExportFileTypes', filename: 'activityExportFileTypes' }
];
